import script from "./CommunityList.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityList.vue?vue&type=script&setup=true&lang=js"

import "./CommunityList.vue?vue&type=style&index=0&id=39eaeafb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39eaeafb"]])

export default __exports__